/* eslint-disable turbo/no-undeclared-env-vars */

const LOGGER_FORCE_BROWSER = 'LOGGER_FORCE_BROWSER';
const LOGGER_FORCE_PROD = 'LOGGER_FORCE_PROD';

/**
 * getEnv safely returns a value from process.env or returns undefined
 * regardless of runtime.
 *
 * In production react builds:
 * * `typeof process === 'undefined'` evaluates as `true`
 * * `typeof process.env === 'undefined'` evaluates as `false`
 *
 * As a result, code such as process?.env?.NODE_DEV will throw
 * process is undefined errors. Instead of dealing with any of this nuance,
 * `getEnv` uses a try/catch. If any type error or reference error is thrown,
 * it returns undefined.
 */
const getEnv = (key: string): string | undefined => {
  // HACK: True story: using process?.env?.NODE_DEV was throwing process is undefined errors.
  try {
    return process.env[key];
  } catch {
    return undefined;
  }
};

/**
 * isBrowser is a helper to determine whether or not this code is being
 * executed in a browser.
 */
const isBrowser = () =>
  getEnv(LOGGER_FORCE_BROWSER) !== undefined ||
  (typeof window !== 'undefined' && typeof window.document !== 'undefined');

/**
 * isProd is a helper to determine whether or not this code is being executed
 * in a production env.
 */
const isProd = () => {
  // HACK: True story: using process?.env?.NODE_DEV was throwing process is undefined errors.
  return getEnv(LOGGER_FORCE_PROD) !== undefined || (getEnv('NODE_ENV') === 'production' ? true : false);
};

export { isBrowser, isProd };
